
import ProdUnitCmp from '@/components/cs/or/ProdUnitCmp.vue' // 마이페이지 주문 목록

export default {
  name: 'OrderList',
  components: {
    ProdUnitCmp
  },
  props: {
    orderList: { // 상품 데이터
      type: [Array, Object],
      default: () => {
        return {}
      }
    },
    orderType: { // 주문리스트 타입
      type: String,
      default: ''
    },
    detailLink: { // 상세 링크
      type: Object,
      default: () => {}
    },
    cart: { // 장바구니 버튼 노출/비노출 여부
      type: Boolean,
      default: true
    },
    reviewPopUpOpen: {
      type: Function,
      default: () => {
      }
    },
    cmpType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
    detailLink: {
      deep: true,
      handler (param) {

      }
    }
  },
  created () {
  },
  mounted () {
  },
  unmounted () {
  },
  methods: {
    btnMore (e) {
      // 버튼 클릭시 노출/비노출
      const unitArry = e.target.closest('.order-list').querySelectorAll('.goods-unit')
      unitArry.forEach((el) => {
        if (el.classList.contains('hide') === true) { // 펼침
          el.classList.replace('hide', 'show')
        } else { // 닫힘
          el.classList.replace('show', 'hide')
        }
      })

      // 버튼 텍스트
      if (e.target.closest('.el-button').innerText.includes('펼쳐') === true) {
        e.target.closest('.el-button').classList.replace('arrow-down', 'arrow-up')
        e.target.closest('.el-button').querySelector('span').innerHTML = '주문 접어보기'
      } else {
        e.target.closest('.el-button').classList.replace('arrow-up', 'arrow-down')
        e.target.closest('.el-button').querySelector('span').innerHTML = '주문 펼쳐보기 ' + '<em>' + (this.orderList.orderProd.length - 2) + '</em>'
      }
    },
    prodUnitClick (event) {
      // SCR_ORB_0001.vue 에 event로 prodUnitClick을 보내시고 orNo클릭하셔서 주문 상세로 들어가도록 함수만 작성하기면 됩니다.
      // SCR_SCH_0001.vue 에 적용되어 있으니 확인 하시고 문의사항 있으시면 말씀주세요. 적용 이후에 주석은 지워주셔도 됩니다.
      console.log('click event', event)
      this.$emit('prod-unit-click', {
        orNo: event.orNo,
        pdNo: event.pdNo,
        item: event.item
      })
    }
  }
}
